import React, { useEffect, useRef, useState } from "react";
import Swiper from "react-id-swiper";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "../portraitSlider/portraitSlider.css";
import SectionHeader from "../sectionHeader/sectionHeader";
import { Link } from "react-router-dom";
import "./articleSlider.css";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { BORDER, VCMS, NAME, RTL, Icon } from "../../global";
import LazyImg from "../lazy/lazy";
import Anchor from "../Link/anchor";
SwiperCore.use([Navigation, Pagination]);

const RecomSlider = (props) => {
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [alselem, setALSElem] = useState([]);
  const [alselemItem, setALSItem] = useState([]);
  const [alsplaylist, setALSPlaylist] = useState(
    VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  const [error, SetError] = useState(false);
  /* eslint-disable no-unused-vars */
  const [elemalsdisplay, setALSElemDisplay] = useState(true);
  const [desc, setDesc] = useState(false);
  const [news, setNews] = useState(false);
  const [viewalsAll, setViewalsAll] = useState("");
  const [viewalsLink, setviewalsLink] = useState("");
  const mounted = useRef(false);
  const params = {
    slidesPerView: 2,
    slidesPerGroup: 2,
    slidesPerGroupSkip: 1,
    spaceBetween: 5,
    centeredSlides: false,
    speed: 800,
    loop: false,
    observer: true,
    observeParents: true,
    rebuildOnUpdate: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 5,
        slidesPerGroup: 1,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      400: {
        slidesPerView: 1.5,
        spaceBetween: 5,
        slidesPerGroup: 1,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      660: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      720: {
        slidesPerView: 2.5,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 8,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 8,
        slidesPerGroup: 4,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
    },
    runCallbacksOnInit: true,
    onInit: (swiper) => {},
  };

  useEffect(() => {
    mounted.current = true;
    const ALSElemDetail = async () => {
      if (mounted.current) {
        setALSElem(props.tabbed ? props.tabid : props.dataset);
        setALSElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.dataset.devices[0].itemVisibility
        );
        setALSItem(props.tabbed ? props.tabid.items : props.dataset.items);
        /* eslint-disable no-unused-vars */

        if (!props.tabbed) {
          if (
            props.dataset.playlistId !== null &&
            props.dataset.playlistId !== ""
          ) {
            ALSplaylistDetail(
              props.dataset.playlistId,
              props.dataset.devices[0].itemSize
            );
          }

          props.dataset.displayNameVisibility === "On Hover" ||
          props.dataset.displayNameVisibility === "Show Always"
            ? setDesc(true)
            : setDesc(false);
          props.dataset.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.dataset.viewAllVisibility === true &&
          props.dataset.viewAllText !== null
            ? setViewalsAll(props.dataset.viewAllText)
            : setViewalsAll("");
          if (
            props.dataset.viewAllVisibility === true &&
            props.dataset.viewAllPage !== null
          ) {
            const link =
              props.dataset.viewAllPage.pageType === "externalPage"
                ? props.dataset.viewAllPage.externalPage
                : props.dataset.viewAllPage.pageType === "internalPage"
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.dataset.viewAllPage.internalPage
                : props.dataset.viewAllPage.urlName !== ""
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.dataset.viewAllPage.urlName
                : "/" +
                  props.match.params.AppId +
                  "/page/" +
                  props.dataset.viewAllPage._id;
            setviewalsLink(link);
          }
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            ALSplaylistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }

          props.tabid.displayNameVisibility === "On Hover" ||
          props.tabid.displayNameVisibility === "Show Always"
            ? setDesc(true)
            : setDesc(false);
          props.tabid.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setViewalsAll(props.tabid.viewAllText)
            : setViewalsAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const link =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setviewalsLink(link);
          }
        }
      }

      /* eslint-disable no-unused-vars */
    };

    const ALSplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */

      if (VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setALSPlaylist(result.data);
            }
          },
          (error) => {}
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setALSPlaylist(result.data);
            }
          },
          (error) => {}
        );
      }

      /* eslint-disable no-unused-vars */
    };

    ALSElemDetail();
    isLoading(false);

    return () => {
      mounted.current = false;
    };
  }, [props.dataset, props.match.params.AppId, props.tabid, props.tabbed]);

  if (elemalsdisplay && !error && !loading) {
    return (
      <div className="artlandscape">
        <SectionHeader
          title={"Related Articles"}
          linkTitle={viewalsAll}
          link={viewalsLink}
          header={props.header}
        ></SectionHeader>
        <div className="container-fluid ">
          <div className="col-sm-12 slider_container">
            <div className="slide-wrapper">
              <Swiper
                className="slide-slider-full swiper container"
                {...params}
                shouldSwiperUpdate
              >
                {alselemItem !== null
                  ? alselemItem.map((item, index) =>
                      item.itemid.devices[0].itemVisibility ? (
                        <div key={index} className="slide-items">
                          <Anchor
                            className={
                              BORDER
                                ? "slide-one slide-two"
                                : "slide-one slide-two no-border"
                            }
                            to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : "/page/" + item.itemid._id
                            }
                          >
                            <div
                              className={
                                props.tag ? "tag-item" : "tag-item hidden"
                              }
                            >
                              <span className="tag">
                                {item.itemid.tag ? item.itemid.tag : NAME}
                              </span>
                            </div>

                            <div
                              orient={"landscape"}
                              className={
                                BORDER ? "slide-image" : "slide-image no-border"
                              }
                            >
                              <LazyImg
                                src={
                                  item.itemid.landscapeThumbnail
                                    ? getAWSUrl() +
                                      item.itemid.landscapeThumbnail.imagekey
                                    : ""
                                }
                                alt=""
                                orient={"landscape"}
                                className={
                                  BORDER
                                    ? RTL
                                      ? ""
                                      : "pos-abs"
                                    : RTL
                                    ? "no-border"
                                    : "pos-abs no-border"
                                }
                              />
                            </div>
                            <div
                              className={
                                desc && news
                                  ? "slide-content showed"
                                  : desc && !news
                                  ? "slide-content"
                                  : "slide-content hidden"
                              }
                            >
                              <h2>
                                {item.itemid.mainHeader !== null
                                  ? item.itemid.mainHeader
                                  : item.itemid.displayName}
                              </h2>
                            </div>
                          </Anchor>
                        </div>
                      ) : (
                        <div
                          key={index}
                          className="none"
                          style={{ display: "none" }}
                        ></div>
                      )
                    )
                  : ""}

                {alselem.playlistId !== null && alselem.playlistId !== undefined
                  ? VCMS === "YouTube"
                    ? alsplaylist.items.map((item, index) => (
                        <div key={index} className="slide-items">
                          <Link
                            className={
                              BORDER
                                ? "slide-one slide-two"
                                : "slide-one slide-two no-border"
                            }
                            to={
                              "/" +
                              props.match.params.AppId +
                              "/videoPage/" +
                              item.contentDetails.videoId
                            }
                          >
                            <div
                              className={
                                props.tag ? "tag-item" : "tag-item hidden"
                              }
                            >
                              <span className="tag">{NAME}</span>
                            </div>
                            {/* {item.ContentType==="Premium"?<Icon></Icon>:""} */}
                            <div
                              className={
                                BORDER ? "slide-image" : "slide-image no-border"
                              }
                              orient={"landscape"}
                            >
                              <LazyImg
                                src={item.snippet.thumbnails.medium.url}
                                alt=""
                                className={RTL ? "" : "pos-abs"}
                                orient={"landscape"}
                              />
                            </div>
                            <div
                              className={
                                desc && news
                                  ? "slide-content showed"
                                  : desc && !news
                                  ? "slide-content"
                                  : "slide-content hidden"
                              }
                            >
                              <h2>{item.snippet.title}</h2>
                            </div>
                          </Link>
                        </div>
                      ))
                    : alsplaylist.playlist.map((item, index) => (
                        <div key={index} className="slide-items">
                          <Link
                            className={
                              BORDER
                                ? "slide-one slide-two"
                                : "slide-one slide-two no-border"
                            }
                            to={
                              "/" +
                              props.match.params.AppId +
                              "/videoPage/" +
                              item.mediaid
                            }
                          >
                            <div
                              className={
                                props.tag ? "tag-item" : "tag-item hidden"
                              }
                            >
                              <span className="tag">
                                {item.Plan ? item.Plan : NAME}
                              </span>
                            </div>
                            {item.ContentType === "Premium" ? (
                              <Icon></Icon>
                            ) : (
                              ""
                            )}
                            <div
                              className={
                                BORDER ? "slide-image" : "slide-image no-border"
                              }
                              orient={"landscape"}
                            >
                              <LazyImg
                                src={item.images[0].src}
                                alt=""
                                className={RTL ? "" : "pos-abs"}
                                orient={"landscape"}
                              />
                            </div>
                            <div
                              className={
                                desc && news
                                  ? "slide-content showed"
                                  : desc && !news
                                  ? "slide-content"
                                  : "slide-content hidden"
                              }
                            >
                              <h2>{item.title}</h2>
                            </div>
                          </Link>
                        </div>
                      ))
                  : ""}
              </Swiper>
              <div
                id={`arrows_${props.tabbed ? props.named : props.name}`}
                className={
                  props.tabbed
                    ? props.named + "prev swiper-arrows swiper-button-prev"
                    : props.name + "prev swiper-arrows swiper-button-prev"
                }
              />
              <div
                id={`arrows_${props.tabbed ? props.named : props.name}`}
                className={
                  props.tabbed
                    ? props.named + "next swiper-arrows swiper-button-next"
                    : props.name + "next swiper-arrows swiper-button-next"
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else if (elemalsdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default RecomSlider;
